import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { inputSliceActions, selectOwnGoalCheckbox } from 'features/input/inputSlice';

import Checkbox from 'atoms/input/Checkbox';

const OwnGoalCheckbox: React.FC = () => {
  const dispatch = useDispatch();

  const ownGoalCheckboxChecked = useSelector(selectOwnGoalCheckbox);

  const check = () => {
    dispatch(inputSliceActions.setOwnGoalCheckbox(!ownGoalCheckboxChecked));
    dispatch(inputSliceActions.setSelectGoalScorer(null));

    if (!ownGoalCheckboxChecked) {
      dispatch(inputSliceActions.setIndirectAssistCheckbox(true));
    }
  };

  return (
    <div id="own-goal-checkbox">
      <Checkbox checked={ownGoalCheckboxChecked} onChange={check} formattedMessageId="checkboxes.ownGoal" />
    </div>
  );
};

export default OwnGoalCheckbox;
